import { render, staticRenderFns } from "./EuroSCOREII.vue?vue&type=template&id=4fab94b0"
import script from "./EuroSCOREII.vue?vue&type=script&lang=js"
export * from "./EuroSCOREII.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports